import { APPID, APPVERSION, QUIZ_INSTANCE } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiGetQuestionResults = async (request, type) => {
    let form = new FormData();
    form.append("mcid", request.mcid);
    form.append("gameMode", request.gamemode);
    form.append("key", request.key);
    form.append("instance", QUIZ_INSTANCE());

    if (typeof request.deckID !== 'undefined' && request.deckID !== null) {
        form.append("deckID", request.deckID);
        if (typeof request.yearvar === 'undefined' && request.deckID !== null) {
            form.append('detail', request.deckID);
            form.append('detailvar', 'deckID');
        }
    }
    
    if (typeof request.questionID !== 'undefined') { 
        form.append('questionID', request.questionID);
        form.append('detailvar2', request.questionID)
    } else if (typeof request.questionid !== 'undefined') { 
        form.append('questionID', request.questionid);
        form.append('detailvar2', request.questionid)
    }

    if (typeof request.yearvar !== 'undefined') {
        form.append("yearvar", request.yearvar);
        if (typeof request.deckID === 'undefined'  && request.yearvar !== null) {
            form.append('detail', request.yearvar);
            form.append('detailvar', 'yearvar');
        }
    }

    if (typeof request.generalOnly !== 'undefined') {
        form.append("generalOnly", request.generalOnly);
    }

    if (typeof request.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", request.tracking.pathname);
        form.append("pagevia", request.tracking.pagevia);
        form.append("action", 'get question results');
        form.append("os", request.tracking.os);
        form.append("ua", request.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getQuestionResults_new"
            },
            data: form
        });

        // console.log(`request: `, request);
        // console.log(`response: `, response);

        let temp = response.data;
        if (typeof temp === 'string') { temp = JSON.parse(temp)}
        
        return temp[0];

    } catch(error) {
        throw error;
    }
}